// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 225) return "static/chunks/225-57671f315ae3f6d7.js";
	if (chunkId === 394) return "static/chunks/394-ffe1c72ee73d9ab2.js";
	if (chunkId === 484) return "static/chunks/484-c3aaa499d97a27c1.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 496 ? "graphql-print" : chunkId) + "." + {"384":"ec02347bce868d4b","496":"83edc8afc0370428","788":"9d61a34ebf98dc6a"}[chunkId] + ".js";
};